import { render, staticRenderFns } from "./WebsiteComponent.vue?vue&type=template&id=67e4c42f&scoped=true&v-if=widgetType%20%3D%3D%3D%20'Website'&"
import script from "./WebsiteComponent.vue?vue&type=script&lang=js&"
export * from "./WebsiteComponent.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteComponent.vue?vue&type=style&index=0&id=67e4c42f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e4c42f",
  null
  
)

export default component.exports